import React from 'react';
import PropTypes from 'prop-types';
import { EVENT_FAQ_CONST, EVENT_FAQ_ANSWERS_CONST } from './data/constants';
import { alcoholRules } from './data/utils';
import AlcoholContent from './content/AlcoholContent';
import AlcoholExpanded from './content/AlcoholExpanded';

const Alcohol = ({ faqData = {}, expanded = false }) => {
  const { OTHER_ALCOHOL_CONSUMPTION_RULES } = EVENT_FAQ_CONST;
  const { alcoholRule, moreInformation, crossedOutRules } = alcoholRules(faqData);
  const hasMoreInformationRules = Array.isArray(moreInformation) && 0 < moreInformation.length;
  const hasCrossedOutRules = 0 < crossedOutRules.length;
  const moreAlcoholRules = !!faqData[OTHER_ALCOHOL_CONSUMPTION_RULES] || hasMoreInformationRules || hasCrossedOutRules;
  if (expanded) {
    return (
      <>
        <AlcoholExpanded
          faqData={faqData}
          alcoholRule={alcoholRule}
          moreAlcoholRules={moreAlcoholRules}
          hasMoreInformationRules={hasMoreInformationRules}
          hasCrossedOutRules={hasCrossedOutRules}
          moreInformation={moreInformation}
          crossedOutRules={crossedOutRules}
        />
      </>
    );
  }
  return (
    <>
      <AlcoholContent
        faqData={faqData}
        alcoholRule={alcoholRule}
        moreAlcoholRules={moreAlcoholRules}
        hasMoreInformationRules={hasMoreInformationRules}
        hasCrossedOutRules={hasCrossedOutRules}
        moreInformation={moreInformation}
        crossedOutRules={crossedOutRules}
      />
    </>
  );
};

Alcohol.propTypes = {
  faqData: PropTypes.object,
  expanded: PropTypes.bool
};

export default Alcohol;
